<template>
  <div class="content widfix">
    <e-breadcrumbs />

    <div>
      <win-layer-pop class="sc-pre-pop">
        <component
          v-if="customComponent"
          :is="customComponent"
          @close="closePoup"
          @agreement="agreementPop"
          :parent-info="popupParams"
        />
      </win-layer-pop>
    </div>
    <form
      id="scMain"
    >
      <span>
        <h1 class="page_title">Service Contracts</h1>
      </span>

      <div class="content_box mt10">
        <div class="content-box">
          <table class="tbl_row border-none">
            <colgroup>
              <col width="100px">
              <col width="170px">
              <col width="80px">
              <col width="150px">
              <col width="80px">
              <col width="150px">
              <col width="100px">
            </colgroup>
            <tbody>
              <tr>
                <th>Effective Date</th>
                <td>
                  <div class="form_wrap t2">
                    <e-date-range-picker-simple
                      id="fromDtToDt"
                      :sdate="scParams.strDt"
                      :edate="scParams.endDt"
                      @change="changeDateRange"
                    />
                  </div>
                </td>
                <th>POR</th>
                <td>
                  <div class="form_wrap t2">
                    <e-auto-complete-place
                      id="polPol"
                      @change="changePol"
                      :ctr-cd="scParams.porCtrCd"
                      :plc-cd="scParams.porPlcCd"
                      :is-char="true"
                      :is-char-alert="true"
                      :list-group-width="'80px'"
                    />
                  </div>
                </td>
                <th>DLY</th>
                <td>
                  <e-auto-complete-place
                    id="podPod"
                    @change="changePod"
                    :ctr-cd="scParams.dlyCtrCd"
                    :plc-cd="scParams.dlyPlcCd"
                    :is-char="true"
                    :is-char-alert="true"
                    :list-group-width="'80px'"
                  />
                </td>
                <td class="border-none">
                  <a class="button blue sh" href="#" @click.prevent="searchScPreview('btn')">{{ $t('btn.CMBTK011') }}<!-- 조회 --></a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- content_box -->
        <div class="content-box">
          <table class="tbl_row mt10 border-none">
            <colgroup>
              <col width="100px">
              <col width="170px">
              <col width="80px">
              <col width="150px">
              <col width="80px">
              <col width="150px">
              <col width="100px">
            </colgroup>
            <tbody>
              <tr>
                <th class="text-center">S/C No.</th>
                <td class="">
                  <input type="text" id="scNo"
                         v-model.trim="scParams.scNo"
                  >
                </td>
                <th>Shipper Name</th>
                <td class="full">
                  <input type="text" id="fmcOrgEnm"
                         v-model.trim="scParams.fmcOrgEnm"
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div><!-- content_box // -->

      <div class="tab">
        <ul>
          <li class="on" id="tab1" @click="selectTab(1)"><a href="javascript:void(0)">All</a></li>
          <li id="tab2" @click="selectTab(2)"><a href="javascript:void(0)">Requested</a></li>
        </ul>
      </div>
      <div class="content_box" v-show="tapState === 1">
        <my-sc-Info-all v-show="tapState === 1" ref="all" :parent-info="scParams"></my-sc-Info-all>
      </div>
      <div class="content_box" v-show="tapState === 2">
        <my-sc-Info-req v-show="tapState === 2" ref="req" :parent-info="scParams"></my-sc-Info-req>
      </div>
    </form>
  </div>
</template>

<script>
import WinLayerPop from '@/pages/trans/popup/WinLayerPop'
import DownloadPop from '@/pages/trans/popup/SpecialRfDgDownloadPop'
import DEXT5Upload from '@/components/DEXT5Upload'
import EBreadcrumbs from '@/components/common/EBreadcrumbs'
import api from '@/api/services/auth'
import EDatePicker from '@/components/common/EDatePickerCustom'
import EInputNumber from '@/components/common/EInputNumber'
import JSZip from 'jszip' // 엑셀 다운로드용 JSZip Component
import { rootComputed, rootMethods } from '@/store/helpers'

export default ({
  name: 'MyScInfoMain',
  components: {
    WinLayerPop,
    DownloadPop,
    DEXT5Upload,
    EBreadcrumbs,
    'my-sc-Info-all': () => import(/* webpackChunkName: "topmenu07_09" */'@/pages/schedule/MyScInfoAll'),
    'my-sc-Info-req': () => import(/* webpackChunkName: "topmenu07_09" */'@/pages/schedule/MyScInfoRequest'),
    MyInfoDextUploader: () => import('@/pages/user/MyInfoDextUploader'),
    EDatePicker,
    EInputNumber,
    EDateRangePickerSimple: () => import('@/components/common/EDateRangePickerSimpleSc'),
    'e-auto-complete-place': () => import('@/components/common/EAutoCompletePlace')
  },
  data () {
    return {
      uploadParam: [],
      selectFunc: null,
      userInfoList: [],
      scParams:
        {
          scNo: '',
          amndNo: '',
          fmcOrgEnm: '',
          searchKnd: '',
          curPage: ''
        },
        fileList: [],
        // 카테고리가 있는 경우
        catList: [],
        fileOriginalName: '',
        customComponent: null,
        dext5Idx: 0,
        isShowDext5: true,
        isShowDext5Pop: false,

        // 다국어 항목 변수
        isKor: true,

        // 영문입력 체크 변수
        valid: '',
        rstList: [],
        gridList: [],
        currentPage: '',
        totalPage: '',
        total: '',
        tapState: 1,
        searchBtnClick: false
    }
  },
  computed: {
    ...rootComputed
  },
  async mounted () {
    console.log('mounted!')

    window.vmAppScMain = this

    //엑셀 다운로드용 JSZip 셋팅
    window.JSZip = window.JSZip || JSZip

    // await this.searchScPreview('init')
  },
  created () {
    // 다국어 항목 제어
    if (this.$i18n.locale !== 'ko-KR') {
      this.isKor = false
    }

    // console.log('this.loginInfo main ::: === ', this.loginInfo)
  },
  methods: {
    async searchScPreview (kind) {
      if (kind === 'btn') {
        this.searchBtnClick = true

        // const isOk = this.checkValidationAll()

        // if (isOk) {
          if (this.tapState === 1) {
            this.scParams.searchKnd = 'all'
            this.$refs.all.search(1, true, this.scParams)
          } else {
            this.scParams.searchKnd = 'req'
            this.$refs.req.search(1, true, this.scParams)
          }
        // }
      } else {
          if (this.tapState === 1) {
            this.scParams.searchKnd = 'all'
            this.$refs.all.search(1, true, this.scParams)
          } else {
            this.scParams.searchKnd = 'req'
            this.$refs.req.search(1, true, this.scParams)
          }
      }
    },
    checkValidationAll () {
      const frm = document.querySelector('#scMain')
      let isAllOk = true

      if (!this.fnValidationScPreview(frm)) {
        isAllOk = false
      }

      return isAllOk
    },
    fnValidationScPreview (frm) {
      console.log('fnValidationScPreview @@@@@')

      if (frm === undefined) {
        frm = document.querySelector('#scMain')
      }

      let isOk = true
      let msg = ''
      let elem
      const elemScNo = frm.querySelectorAll('#scNo')
      const elemLinsNo = frm.querySelectorAll('#amndNo')

      const hasAnyInput = this.$ekmtcCommon.isEmpty(this.scParams.scNo)

      if (this.$ekmtcCommon.isEmpty(this.scParams.scNo)) {
        msg = 'Please input SC No.'

        this.$ekmtcCommon.showErrorTooltip(elemScNo, msg)
        isOk = false
      } else {
        this.$ekmtcCommon.hideErrorTooltip(elemScNo)
        isOk = true
      }

      return isOk
    },
    changeDateRange (s, e) {
      this.scParams.strDt = s
      this.scParams.endDt = e

      // this.checkSearchValidation('fromDtToDt')
    },
    // '출발' 자동완성 change event
    changePol (vo) {
      this.scParams.porCtrCd = vo.ctrCd
      this.scParams.porPlcCd = vo.plcCd
      this.scParams.polNm = vo.plcEnm
      const frm = document.querySelector('#scMain')
      const elem = frm.querySelector('#polPol')
      this.$ekmtcCommon.hideErrorTooltip(elem)
    },
    // '도착' 자동완성 change event
    changePod (vo) {
      this.scParams.dlyCtrCd = vo.ctrCd
      this.scParams.dlyPlcCd = vo.plcCd
      this.scParams.podNm = vo.plcEnm
      const frm = document.querySelector('#scMain')
      const elem = frm.querySelector('#podPod')
      this.$ekmtcCommon.hideErrorTooltip(elem)
    },
    async selectTab (tab) {
        $('.tab li').removeClass('on')

        $('#tab' + tab).addClass('on')

        this.tapState = tab

        if (tab === 2 && !this.searchBtnClick) {
          this.scParams.searchKnd = 'req'
          await this.$refs.req.search(1, true, this.scParams)
        }
    }
  }
})
</script>
<style scoped>
.popup_dim .layer_close {z-index: 2998 !important}
.popup_dim2 {z-index: 2999 !important}

.border-none {
  border : 0 !important;
}

table th, td {
    border : 0 !important;
    background: white;
}

table th, td {
    padding: 8px 0 0 10px !important;
    border : 0 !important;
    background: white;
}

table th, td {
    text-align : right !important;
}

.bul_list_sm li::before {
  content: none !important;
}

/* .input_calendar.mid, .input_calendar.mid input {
    width: 160px !important;
} */

.list-group {
    max-width: 230px !important;
}

</style>
